import React from 'react'
import type { Icon } from 'shared/utils'

export const CameraSight = (props: Icon) => {
    const { color = 'white', size, ...otherProps } = props
    return (
        <svg
            height={size}
            width={size}
            viewBox="0 0 318 318"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...otherProps}>
            <path
                d="M269.778 0.5C267.977 0.5 266.5 1.93316 266.5 3.72222C266.5 5.51128 267.977 6.94444 269.778 6.94444H292C302.472 6.94444 310.944 15.2615 310.944 25.5V47.2778C310.944 49.0668 312.422 50.5 314.222 50.5C316.023 50.5 317.5 49.0668 317.5 47.2778V25.5C317.5 11.6834 306.074 0.5 292 0.5H269.778Z"
                fill={color}
                stroke={color}
                strokeLinecap="round"
            />
            <path
                d="M0.5 47.2778C0.5 49.0668 1.97708 50.5 3.77778 50.5C5.57847 50.5 7.05556 49.0668 7.05556 47.2778L7.05555 25.5C7.05555 15.2615 15.5277 6.94445 26 6.94445L48.2222 6.94445C50.0229 6.94445 51.5 5.51129 51.5 3.72223C51.5 1.93317 50.0229 0.500002 48.2222 0.500002L26 0.500003C11.9263 0.500003 0.499998 11.6834 0.499999 25.5L0.5 47.2778Z"
                fill={color}
                stroke={color}
                strokeLinecap="round"
            />
            <path
                d="M317.5 253.778C317.5 251.968 316.032 250.5 314.222 250.5C312.412 250.5 310.944 251.968 310.944 253.778L310.944 276C310.944 286.463 302.463 294.944 292 294.944L269.778 294.944C267.968 294.944 266.5 296.412 266.5 298.222C266.5 300.032 267.968 301.5 269.778 301.5L292 301.5C306.083 301.5 317.5 290.083 317.5 276L317.5 253.778Z"
                fill={color}
                stroke={color}
                strokeLinecap="round"
            />
            <path
                d="M48.2222 301.5C50.0325 301.5 51.5 300.032 51.5 298.222C51.5 296.412 50.0325 294.944 48.2222 294.944L26 294.944C15.5373 294.944 7.05555 286.463 7.05556 276L7.05556 253.778C7.05556 251.968 5.58805 250.5 3.77778 250.5C1.96751 250.5 0.5 251.968 0.5 253.778L0.499998 276C0.499997 290.083 11.9167 301.5 26 301.5L48.2222 301.5Z"
                fill={color}
                stroke={color}
                strokeLinecap="round"
            />
        </svg>
    )
}
